var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Member","items":_vm.items,"doc":_vm.doc}})
}
var staticRenderFns = []

export { render, staticRenderFns }